export const DEMO_SCOPE = {
  exchange: 'BITGET',
  marketType: 'PERPS'
};
export const PUBLIC_DEMO_PATH = `/mtf-signals-v2/${DEMO_SCOPE.exchange}/${DEMO_SCOPE.marketType}`;
